import PropTypes from 'prop-types';
import React from 'react';
import { CheckCircleFill, Info, X } from 'react-bootstrap-icons';

import useProduct from '../../hooks/use_product';
import useTranslation from '../../hooks/use_translation';
import BtnIcon from '../framework/buttons/btn_icon';
import Loader from '../framework/loader';

const ItemButtonProduct = ({ handleAction, inCart, isLoading, product_id }) => {
	const { items: products } = useProduct({
		include_products: [product_id],
	});

	const { t } = useTranslation('component_item_button_product');

	const product = products[0];
	if (!product) return <></>;

	const statuses = {
		no: {
			className: `btn-accent text-white`,
			title: t('t1', {
				price: `${
					product?.product_variant?.price_discount > 0
						? product?.product_variant?.price_discount
						: product?.product_variant?.price
				} ${product?.product_variant?.currency.symbol}`,
			}),
		},
		other: {
			className: 'bg-green-100 border-0 btn-light text-dark',
			extra: {
				icon: <Info className="" />,
			},
			icon: <CheckCircleFill className="small ms-1" />,
			title: t('t2'),
		},
		replaced: {
			className: 'bg-green-100 text-dark',
			extra: {
				icon: <Info className="" />,
			},
			title: t('t3'),
		},
		yes: {
			className: 'btn-success border-0 text-white',
			extra: {
				icon: <X className="" />,
			},
			icon: <CheckCircleFill className="small ms-1" />,
			title: t('t4'),
		},
	};

	return (
		<>
			<button
				className={`btn rounded-pill btn-shop flex-grow-1 ${
					statuses[inCart?.status]?.className
				}`}
				onClick={handleAction}
			>
				{isLoading && <Loader color="light" />}
				{!isLoading && (
					<>
						{statuses[inCart.status]?.title && (
							<span>{statuses[inCart.status]?.title}</span>
						)}

						{statuses[inCart.status]?.icon && (
							<>{statuses[inCart.status]?.icon}</>
						)}
					</>
				)}
			</button>

			{statuses[inCart.status]?.extra && (
				<BtnIcon
					className={`ms-1 ${statuses[inCart.status]?.extra?.className}`}
					linkType="button"
					onClick={handleAction}
					type="button"
					variant="light"
				>
					{statuses[inCart.status]?.extra?.icon}
				</BtnIcon>
			)}
		</>
	);
};

ItemButtonProduct.propTypes = {
	handleAction: PropTypes.func,
	inCart: PropTypes.object,
	isLoading: PropTypes.bool,
	product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ItemButtonProduct;
